<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>今日考试列表</span>
      </div>
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column label="序号">
          <template slot-scope="scope">
            {{(scope.$index)+1}}
          </template>
        </el-table-column>
        <el-table-column prop="id" label="考试编号" >
        </el-table-column>
        <el-table-column label="考试名称" >
          <template slot-scope="scope">
            {{scope.row.name}}
          </template>
        </el-table-column>
        <el-table-column label="时间" width="350px">
          <template slot-scope="scope">
            {{scope.row.begin_dt}}~~{{scope.row.end_dt}}
          </template>
        </el-table-column>
        <el-table-column prop="total" label="考试人数">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div v-if="scope.row.status==0">
              <el-button v-if="scope.row.exam_plan.length>0" @click="beginExam(scope.row)">开始考试</el-button>
              <el-button v-else @click="noPlan">开始考试</el-button>
            </div>
            <div v-else-if="scope.row.status==1">
              正在考试...
            </div>
            <div v-else>
              考试已结束
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

  </div>
</template>

<script>
    import Pagination from '../components/Pagination'

    export default {
        components: {Pagination},
        props: {},
        data() {
            return {
                total: 0,
                tableData: []
            };
        },
        computed: {},
        created() {
            this.getData();
        },
        methods: {
            beginExam(row){
                this.$http.setBegin({exam_id:row.id}).then(res=>{
                    this.getData();
                })
            },
            noPlan() {
                this.$message.error('该考试没有安排考场！')
            },
            getData() {
                this.$http.todayExam()
                    .then(res => {
                        this.tableData = res.data;
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            handleEdit(scope) {
            },
            confirmSave() {
                const isEdit = this.dialogType === 'edit'
                if (isEdit) {
                    this.$http.updateTeacher(this.student.id, this.student).then(res => {
                        this.dialogVisible = false
                        this.$notify({
                            title: 'Success',
                            message: '操作成功！',
                            type: 'success'
                        })
                        this.getData()
                    })
                } else {
                    this.$http.addTeacher(this.student).then(res => {
                        this.dialogVisible = false
                        this.$notify({
                            title: 'Success',
                            message: '操作成功！',
                            type: 'success'
                        })
                        this.getData()
                    })
                }
            },
            handleDelete({$index, row}) {
                this.$confirm('确定要删除此条吗?', '警告', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.$http.deleteTeacher(row.id).then(res => {
                            this.tableData.splice($index, 1)
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            })
                        });

                    })
                    .catch(err => {
                        console.error(err)
                    })
            },

        },
    };
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/page/dashboard.vue